export default {
    sleeveList: [
        {
            title: '袖长',
            list: [
                '8',
                '10',
                '12',
                '14',
                '16'
            ]
        }
    ]
}